<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="file-contract"/>&nbsp;Registrar Contrato
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
          <div class="row mt-4">
            <div class="col-sm-6">
              <h4 class="font-info">Datos Generales</h4>
            </div>
          </div>
          <sys-form :inputs="contract_details" v-if="loaded"/><hr class="mt-5">
          <div v-if="isMixedRate">
            <sys-form :inputs="mixed_rate" v-if="loaded"/><hr class="mt-5">
          </div>
          <sys-form :inputs="bank" v-if="loaded"/>
        <!--end: Details -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: 'contracts' })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import contractsService from '@/services/contracts'
import investorsService from '@/services/investors'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'
import moment from 'moment'

export default {
  name: 'ContractCreate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      loaded: false,
      contract_details: {
        investor_id: {
          name: 'Acreedor',
          hint: 'Selecciona un Acreedor',
          value: null,
          type: 'select',
          options: [],
          size: 8,
          validate: 'required'
        },
        contract_type_id: {
          name: 'Tipo',
          hint: 'Seleccione el tipo',
          value: null,
          type: 'select',
          options: [],
          validate: 'required'
        },
        folio: {
          name: 'Folio de Contrato',
          hint: 'Folio',
          value: '',
          type: 'text',
          size: 6,
          validate: 'required'
        },
        parent_id: {
          name: 'Contrato a Renovar',
          hint: 'Selecciona un Contrato',
          value: null,
          type: 'select',
          options: [],
          size: 6
        },
        interest_rate: {
          name: 'Tasa de Interés (%)',
          hint: 'Tasa de interés',
          value: '',
          min: 0,
          max: 100,
          type: 'number',
          size: 4,
          validate: 'required'
        },
        rate_type: {
          name: 'Tipo de Interés',
          hint: 'Selecione un Tipo',
          value: { value: 0, text: 'Tasa Neta' },
          type: 'select',
          options: [
            { value: 0, text: 'Tasa Neta' },
            { value: 1, text: 'Tasa Bruta' }
          ],
          validate: 'required',
          size: 4
        },
        date_init: {
          name: 'Fecha de Inicio',
          hint: 'dd/mm/aaaa',
          value: '',
          type: 'date',
          size: 4,
          validate: 'required'
        },
        frequency_id: {
          name: 'Frecuencia de Pago',
          hint: 'Sellecione la frecuencia de pago',
          value: null,
          type: 'select',
          options: [],
          validate: 'required',
          size: 4
        },
        cut_day: {
          name: 'Día de corte',
          hint: 'Selecione un día',
          value: null,
          type: 'select',
          options: [
            { value: 7, text: '7' },
            { value: 15, text: '15' },
            { value: 21, text: '21' },
            { value: 'last_day', text: 'Último' }
          ],
          validate: 'required',
          size: 4
        },
        payment_method_id: {
          name: 'Método de Pago',
          hint: 'Selecciona un Método de Pago',
          value: null,
          type: 'select',
          options: [],
          size: 4
        }
      },
      mixed_rate: {
        1: {
          name: 'Efectivo',
          hint: 'Selecciona una parte del interes',
          value: null,
          type: 'number',
          min: 0,
          max: 100
        },
        2: {
          name: 'Transferencia Bancaria',
          hint: 'Selecciona una parte del interes',
          value: null,
          type: 'number',
          min: 0,
          max: 100
        },
        3: {
          name: 'Cheque',
          hint: 'Selecciona una parte del interes',
          value: null,
          type: 'number',
          min: 0,
          max: 100
        }
      },
      bank: {
        bank_account_id: {
          name: 'Cuenta Bancaria',
          hint: 'Selecciona una cuenta bancaria',
          value: null,
          type: 'select',
          options: [],
          size: 12
        }
      },
      bank_accounts: {}
    }
  },

  created: function () {
    investorsService.withContracts().then(res => {
      this.contract_details.investor_id.options = res.map(investor => {
        return (investor.corporate_name) ? { value: investor.id, text: investor.corporate_name } : { value: investor.id, text: investor.fullname }
      })
    })

    contractsService.getTypes().then(res => {
      this.contract_details.contract_type_id.options = res.data.map(data => {
        return { value: data.id, text: `${data.name} (${data.code})` }
      })
    })

    contractsService.getFrequencies().then(res => {
      this.contract_details.frequency_id.options = res.data.map(data => {
        return { value: data.id, text: `${data.name}` }
      })
    })

    contractsService.getPaymentMethods().then(res => {
      this.contract_details.payment_method_id.options = res.data.map(data => {
        return { value: data.id, text: `${data.name}` }
      })
    })

    this.loaded = true
  },

  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let body = this.processForm(this.contract_details)

          const bankAccount = this.processForm(this.bank)

          body = { ...body, ...bankAccount }

          if (this.isMixedRate) body['mixed_rate'] = this.processForm(this.mixed_rate)
          let service = contractsService.post(body)

          this.sendForm(service).then(res => {
            this.$router.push({ name: 'contracts', props: { contract: res } })
          }).catch(err => {
            console.log(JSON.stringify(err.statusText))
          })
        }
      })
    }
  },

  watch: {
    'contract_details.investor_id.value': function (newInvestor, oldInvestor) {
      const id = newInvestor.value
      contractsService.fromInvestor(id).then(res => {
        this.contracts = res.data
        this.contract_details.parent_id.options = res.data.map(contract => {
          return {value: contract.id, text: contract.folio}
        })
      })

      investorsService.banks(id).then(res => {
        this.bank.bank_account_id.options = res.map(bank => {
          return {
            value: bank.id,
            text: `${bank.bank}, ${bank.account}, ${bank.clabe}`
          }
        })
      })
    },
    'contract_details.parent_id.value': function (newContract, oldContract) {
      let contractSelected = null
      let contracts = this.contracts
      Object.keys(contracts).forEach(function (contract) {
        if (newContract.value == contracts[contract].id) {
          contractSelected = contracts[contract]
        }
      })

      if (!contractSelected) {
        this.contract_details.cut_day_id.value = ''
        this.contract_details.interest_rate.value = ''
        this.contract_details.frequency_id.value = ''
        return
      }

      this.contract_details.cut_day.value = {
        value: contractSelected.cut_day_id,
        text: contractSelected.cut_day
      }

      this.contract_details.frequency_id.value = {
        value: contractSelected.frequency_id,
        text: contractSelected.frequency
      }

      this.contract_details.interest_rate.value = contractSelected.interest_rate

      this.contract_details.contract_type_id.value = {
        value: contractSelected.contract_type_id,
        text: contractSelected.type
      }

      this.contract_details.date_init.value = moment().format('YYYY-MM-DD')
    },
    'contract_details.contract_type_id.value': function (newType, oldType) {
      if (newType.value == 2) {
        this.contract_details.payment_method_id.disabled = true
      } else {
        this.contract_details.payment_method_id.disabled = false
      }
      this.contract_details.payment_method_id.value = ''
    }
  },

  computed: {
    isMixedRate: function () {
      const type = this.contract_details.contract_type_id.value
      if (type && type.value == 2) return true
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contracts/ContractCreate.vue